import { render, staticRenderFns } from "./LivingOptions.vue?vue&type=template&id=2c7df8cd&"
import script from "./LivingOptions.vue?vue&type=script&lang=js&"
export * from "./LivingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports